class ProductBundle extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.url = this.dataset.url;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async connectedCallback() {
    try {
      const response = await fetch(this.url);

      if(!response.ok){
        throw new Error('Failed to fetch data.');
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('[data-bundle-container]');
      const recommendationList = html.querySelector('[data-bundle-items]');

      if (recommendations && recommendations.innerHTML.trim().length && recommendationList) {
        this.container.innerHTML = recommendations.innerHTML;
        this.bind();
      } else {
        this.container.innerHTML = '';
      }
    } catch(error){
      console.log('Error:', error);
    } finally {
      this.bundleItems = this.querySelectorAll('.bundle-item');
      this.submitButton = this.querySelector('.product-bundle__button');
      this.checkboxes = this.querySelectorAll('input[type="checkbox"]');
      this.notice = this.querySelector('.product-bundle__notice');

      this.setCheckboxes(this.checkboxes);
      
      this.checkboxes.forEach((box) => {
        box.addEventListener('change', (event) => {
          this.setCheckboxes(this.checkboxes);
          box.ariaChecked = box.ariaChecked !== 'true';
          box.checked ? box.checked = true : box.checked = false;
        });
      });
    }
  }

  bind() {
    const bundleAddAllBtn = this.querySelector('#submitProductBundle');
    bundleAddAllBtn.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setCheckboxes(checkboxes) {
    const boxes = [...checkboxes];
    const count = boxes.filter(box => box.checked).length;

    this.submitButton.classList.toggle('hidden', count === 0);
    this.notice.classList.toggle('hidden', count > 0);
    this.submitButton.textContent = count === 1 ? 'Add to cart' : `Add ${count === checkboxes.length ? 'all' : ''} ${count} to cart`;
  }

  openCart() {
    setTimeout(() => {this.cart.classList.add('animate', 'active')});

    this.cart.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.cart.classList.contains('is-empty') ? this.cart.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.cart.querySelector('.drawer__inner') || this.cart.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  async onSubmitHandler(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    const bundleItems = this.querySelectorAll('.bundle-item');
    let productData = [];

    bundleItems.forEach(item => {
      const checkboxInput = item.querySelector('input[type="checkbox"]');

      if(!checkboxInput.checked) return;
      
      let data = {}
      data['id'] = checkboxInput.value;
      data['quantity'] = 1;
      productData.push(data);

      item.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      item.classList.add('bundle-item--is-added');
    })  
    
    const newFormData = {
      items: [...productData]
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newFormData)
      });

      if(!response.ok){
        throw new Error ('Failed to post products.');
      }

      await this.renderCartComponents();

      if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty'); 
      this.openCart();

    } catch(error) {
      console.log('Error:', error);
    } finally {

      this.submitButton.removeAttribute('aria-disabled');
      this.submitButton.classList.remove('loading');

      const addedBundleItems = this.querySelectorAll('.bundle-item--is-added');

      addedBundleItems.forEach((item) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        checkbox.ariaChecked = checkbox.ariaChecked !== 'true';
        checkbox.checked = false;
        checkbox.setAttribute('tabindex', '-1');
        checkbox.classList.add('hidden');
        item.querySelector('.loading-overlay__spinner').classList.add('hidden');
        item.querySelector('.bundle-item__success').classList.remove('hidden');
      });

      this.submitButton.classList.add('hidden');
      this.notice.classList.remove('hidden');

      if(this.bundleItems.length === addedBundleItems.length) this.notice.classList.add('hidden');
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        selector: "#CartDrawer"
      },
      {
        id: "cart-icon-bubble",
        selector: "#cart-icon-bubble"
      }
    ];
  }

  async renderCartComponents() {
    try {
      const response = await fetch(`${routes.cart_url}`);

      if(!response.ok){
        throw new Error('Failed to fetch cart components.');
      } 

      const text = await response.text();
      this.getSectionsToRender().forEach((section) => {
        const updatedHTML = getSectionInnerHTML(text, section.selector);
        document.getElementById(section.id).innerHTML = updatedHTML;
      });
    } catch(error){
      console.log('Error:', error);
    }
  }

}

customElements.define('product-bundle', ProductBundle);

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}


class BundleVariantSelects extends ProductBundle {
  constructor() {
    super();

    this.product = this.dataset.product;
    this.checkbox = document.querySelector(`input[id="product-bundle-${this.product}"]`);
    this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
  }

  connectedCallback() {
    this.fieldsets.forEach((fieldset, index) => {
      const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]')); 

      inputs.forEach((input) => {
        input.addEventListener('change', (event) => {
          this.getSelectedOptions();
          this.updateAllVariantOptions(index + 1)
          this.updateFieldsetLabel(event.target);
          this.updateCurrentVariant();

          if(this.currentVariant && this.currentVariant.available) {
            this.updateProductId();
          }
        });
      });
    });    
  }

  updateFieldsetLabel(target) {
    const selectedSwatchValue = target.closest('.bundle-item__options').querySelector('[data-selected-value');
    if (selectedSwatchValue) selectedSwatchValue.innerHTML = target.value;
  }

  getSelectedOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateCurrentVariant() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.options.every((option, index) => option === this.options[index]);
    });
  }

  updateProductId() {
    this.checkbox.value = this.currentVariant.id;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  } 

  updateFieldsetOptions(index, variants) {
    const fieldset = this.fieldsets[index];
    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    let currentSelectedInput = fieldset.querySelector('input[type="radio"]:checked');
    let currentSelectedValue = currentSelectedInput ? currentSelectedInput.value : null;

    inputs.forEach(input => {
      const isAvailable = variants.some(variant => variant.options[index] === input.value);
      input.disabled = !isAvailable;
    });

    const currentIsStillValid = variants.some((variant) => {
      return variant.options[index] === currentSelectedValue;
    });

    if(!currentIsStillValid) {
      const firstAvailable = inputs.find(input => !input.disabled);
      if(firstAvailable) {
        this.updateFieldsetLabel(firstAvailable);
        firstAvailable.checked = true;
        return firstAvailable.value;
      }
      return null;
    }

    return currentSelectedValue;
  }

  updateAllVariantOptions(startIndex = 0) {
    
    let variants = this.getVariantData();
    
    for (let i = 0; i < startIndex; i++) {
      if(this.options[i] != null) {
        variants = variants.filter((variant) => { 
          return variant.options[i] === this.options[i] && variant.available;
        });
      }
    }

    for(let i = startIndex; i < this.fieldsets.length; i++) {
      const selectedOption = this.updateFieldsetOptions(i, variants);
      this.options[i] = selectedOption;
      variants = variants.filter((variant) => { 
        return variant.options[i] === selectedOption;
      });
    }
  }

}

customElements.define('bundle-variant-selects', BundleVariantSelects);
